module.exports = __webpack_public_path__ + "static/media/Eamcet-Exam.e183105b.png";